import {
    ComponentManager,
    Factory,
    ICustomBinding,
    IWizardGroupFactoryConstructorParameter,
    type LabelViewModel as LabelViewModelT,
    type WizardGroupFactory
} from "radpresentation.htmlclient.defaultviewextensions";

export default class TaskDescriptionBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.taskDescription = {
            init: (element: HTMLElement, valueAccessor: () => any) => {
                let control = $(element);
                let options = valueAccessor();
                let isSummaryViewMode = options.isSummaryViewMode;
                let layout = options.layout;
                let context = options.context;
                let WFEUserTaskCompleteInformationDTO = options.WFEUserTaskCompleteInformationDTO();

                function getSelectedIndex(dto) {
                    if (dto == null) {
                        return 0;
                    }

                    if (dto.Steps.length > 0) {
                        for (let i = 0; i < dto.Steps.length; i++) {
                            let Step = dto.Steps[i];

                            if (Step.IsActive === true) {
                                return i;
                            }
                        }
                    }

                    return 0;
                }

                function createDetailViewGroup(dto) {
                    let result = {} as any;
                    let currentItem = result;

                    if (dto == null) {
                        return null;
                    }

                    if (dto.Steps.length > 0) {
                        for (let i = 0; i < dto.Steps.length; i++) {
                            let Step = dto.Steps[i];
                            currentItem = embedSingleWizardGroup(currentItem, Step, dto);
                        }
                    } else {
                        embedHiddenWizardGroup(currentItem, dto);
                    }

                    return result.detailViewGroups[0];
                }

                function embedSingleWizardGroup(parent, Step, dto) {
                    if (parent == null || Step == null)
                        return undefined;

                    const child = {
                        uiGenerator: 'WizardGroup',
                        layout: layout,
                        caption: Step.Name,
                        name: Step.TechnicalName,
                        isEnabled: false,
                        items: createWizardGroupItems(Step, dto),
                        detailViewGroups: []
                    };

                    parent.detailViewGroups = [child];

                    return child;
                }

                function embedHiddenWizardGroup(parent, dto) {
                    if (parent == null)
                        return undefined;

                    const child = {
                        uiGenerator: 'WizardGroup',
                        layout: layout,
                        isEnabled: false,
                        isVisible: false,
                        items: createWizardGroupItems({IsActive: true}, dto)
                    };

                    parent.detailViewGroups = [child];

                    return child;
                }

                function createWizardGroupItems(Step, dto) {
                    let LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
                    let result = [];

                    if (Step.IsActive === true) {
                        result = [
                            {
                                uiGenerator: 'Label',
                                viewModel: new LabelViewModel({
                                    locator: 'Task.Title',
                                    caption: dto.Title
                                })
                            },
                            {
                                uiGenerator: 'Label',
                                viewModel: new LabelViewModel({
                                    locator: 'Task.Description',
                                    caption: dto.Description
                                })
                            },
                            {
                                uiGenerator: 'Label',
                                viewModel: new LabelViewModel({
                                    locator: 'Task.Footer',
                                    caption: ko.computed(function () {
                                        let result = '';

                                        result += dto.DueDateLabel;
                                        result += dto.DueDate;
                                        result += ' | ';
                                        result += dto.AssigneeLabel;
                                        result += dto.Assignee;
                                        result += ' | ';
                                        result += dto.IsCompletedLabel;
                                        result += dto.IsCompleted;
                                        result += ' | ';
                                        result += dto.Instance;

                                        return result;
                                    })
                                })
                            }
                        ];
                    }

                    return result;
                }

                const groupFactory = Factory.createInstance<WizardGroupFactory>('WizardGroup', {
                    selectedIndex: getSelectedIndex(WFEUserTaskCompleteInformationDTO),
                    context: context,
                    layout: layout,
                    isSummaryViewMode: isSummaryViewMode,
                    detailViewGroup: createDetailViewGroup(WFEUserTaskCompleteInformationDTO)
                } as IWizardGroupFactoryConstructorParameter);

                groupFactory.getTupleAsync().then(tuple => tuple.control.appendTo(control));

                if (context != null) {
                    context.setCreatedFactory(groupFactory);
                }
            }
        };
    }
}